/* ============================================================
   NLO THEME — athlete.js
   Athlete card modal open/close
   ============================================================ */
'use strict';

const athleteModal = document.getElementById('athlete-modal');
const athleteModalClose = document.getElementById('athlete-modal-close');
const athleteModalOverlay = document.getElementById('athlete-modal-overlay');

function openAthleteModal(data) {
  if (!athleteModal) return;
  const nameEl    = athleteModal.querySelector('.athlete-modal__name');
  const sportEl   = athleteModal.querySelector('.athlete-modal__sport');
  const statusEl  = athleteModal.querySelector('.athlete-modal__status');
  const ageEl     = athleteModal.querySelector('.athlete-modal__age');
  const locationEl= athleteModal.querySelector('.athlete-modal__location');
  const bioEl     = athleteModal.querySelector('.athlete-modal__bio');
  const imageEl   = athleteModal.querySelector('.athlete-modal__image');
  const socialEl  = athleteModal.querySelector('.athlete-modal__social');

  if (nameEl)     nameEl.textContent     = data.name || '';
  if (sportEl)    sportEl.textContent    = data.sport || '';
  if (statusEl)   statusEl.textContent   = data.status || '';
  if (ageEl)      ageEl.textContent      = data.age ? `Age: ${data.age}` : '';
  if (locationEl) locationEl.textContent = data.location || '';
  if (bioEl)      bioEl.textContent      = data.bio || '';
  if (imageEl && data.image) { imageEl.src = data.image; imageEl.alt = data.name || 'Athlete'; }
  if (socialEl)   socialEl.textContent   = data.social ? `@${data.social}` : '';

  athleteModal.classList.add('is-open');
  athleteModal.setAttribute('aria-hidden', 'false');
  document.body.classList.add('no-scroll');
}

function closeAthleteModal() {
  athleteModal?.classList.remove('is-open');
  athleteModal?.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('no-scroll');
}

athleteModalClose?.addEventListener('click', closeAthleteModal);
athleteModalOverlay?.addEventListener('click', closeAthleteModal);

document.querySelectorAll('.js-open-athlete-modal').forEach(btn => {
  btn.addEventListener('click', () => {
    const card = btn.closest('[data-athlete]');
    if (!card) return;
    openAthleteModal({
      name:     card.dataset.name,
      sport:    card.dataset.sport,
      status:   card.dataset.status,
      age:      card.dataset.age,
      location: card.dataset.location,
      bio:      card.dataset.bio,
      image:    card.dataset.image,
      social:   card.dataset.social
    });
  });
});
